import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  onActionEditar: (idControleResiduos: number, openState: boolean) => void;
  onActionDeletar: (idControleResiduos: number, openState: boolean) => void;
};

export const GenerateResiduosColumnDefinition = ({ onActionEditar, onActionDeletar }: Props): GridColDef[] => {
  return [
    { field: "ano", headerName: "Ano", width: 70 },
    { field: "mes", headerName: "Mês", width: 100 },
    { field: "volumeM3", headerName: "Volume em M³", width: 120 },
    {
      field: "valorCacamba",
      filterable: false,
      headerName: "Valor Unitário",
      flex: 1,
      minWidth: 120,
      sortable: false,
      valueFormatter: (params) => {
        if (params == null) return "";
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(params);
      },
    },
    { field: "qtdeTotal", headerName: "Qtde Total", width: 100 },
    { field: "volumeTotal", headerName: "Volume Total", width: 120 },
    {
      field: "valorTotal",
      filterable: false,
      headerName: "Valor Total",
      flex: 1,
      minWidth: 120,
      sortable: false,
      valueFormatter: (params) => {
        if (params == null) return "";
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(params);
      },
    },
    { field: "efetivoMes", headerName: "Efetivo do Mês", width: 120 },
    { field: "mediaTrabalhador", headerName: "Média Por Trabalhador", width: 170 },
    { field: "areaConstruida", headerName: "Área Construída", width: 150 },
    { field: "mediaArea", headerName: "Média Por Área", width: 150 },
    { field: "metaAprovacao", headerName: "Meta Aprovação", width: 130 },
    { field: "observacao", headerName: "Observação", flex: 1, minWidth: 150 },
    {
      field: "idControleResiduos",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idControleResiduos, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>

          <IconButton onClick={() => onActionDeletar(params.row.idControleResiduos, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
